import React from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';
import Spinner from 'components/Spinner/desktop';

import ProvidersCustomBlock from './Blocks/ProvidersCustomBlock';
import GamesCustom from './Blocks/GamesCustom';
import NotificationsCustom from './Blocks/NotificationsCustom';
import SocialMedia from './Blocks/SocialMedia';

import './Custom.scss';
import BetsLimit from 'features/betsLimits/view/desktop/BetsLimit';

const b = block('custom-page');

const Custom = () => {
  const { actionProcessing } = useSelector(state => state.creativeFunctionality, shallowEqual);
  const { id } = useSelector(state => state.auth, shallowEqual);

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <BetsLimit />
      <div className={b('wrapper')}>
        {(id === 64 || id === 62) && (
          <>
            <ProvidersCustomBlock />
            <GamesCustom />
          </>
        )}
        <NotificationsCustom />
        <SocialMedia />
      </div>
    </div>
  );
};

export default Custom;
